import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { chevronToggle, fileArrowDown, location, openNew, phoneMobileOrange, phoneOrange, sortable, sortAsc, sortDesc, } from '@ibk/shared-assets';
import accountPj from '@ibk/shared-assets/icons/accountPj.svg';
import actionAddThin from '@ibk/shared-assets/icons/action-add-thin.svg';
import actionAdd from '@ibk/shared-assets/icons/action-add.svg';
import actionBack from '@ibk/shared-assets/icons/action-back.svg';
import actionBlockOrange from '@ibk/shared-assets/icons/action-block-orange.svg';
import actionBlock from '@ibk/shared-assets/icons/action-block.svg';
import actionCancelBilling from '@ibk/shared-assets/icons/action-cancel-billing.svg';
import actionCheckGreen from '@ibk/shared-assets/icons/action-check-green.svg';
import actionClockBlue from '@ibk/shared-assets/icons/action-clock-blue.svg';
import actionCloseOrange from '@ibk/shared-assets/icons/action-close-orange.svg';
import actionCloseWhite from '@ibk/shared-assets/icons/action-close-white.svg';
import actionClose from '@ibk/shared-assets/icons/action-close.svg';
import copyBlack from '@ibk/shared-assets/icons/action-copy-black.svg';
import copyOrange from '@ibk/shared-assets/icons/action-copy-orange.svg';
import actionCopyWhite from '@ibk/shared-assets/icons/action-copy-white.svg';
import actionDeleteOrange from '@ibk/shared-assets/icons/action-delete-orange.svg';
import actionDelete from '@ibk/shared-assets/icons/action-delete.svg';
import actionEdit from '@ibk/shared-assets/icons/action-edit.svg';
import envelopeOpenDollar from '@ibk/shared-assets/icons/action-envelope-open-dollar-orange.svg';
import actionErrorRed from '@ibk/shared-assets/icons/action-error-red.svg';
import actionHexagonExclamation from '@ibk/shared-assets/icons/action-hexagon-exclamation.svg';
import actionInformationDark from '@ibk/shared-assets/icons/action-information-dark.svg';
import actionInformationGray from '@ibk/shared-assets/icons/action-information-gray.svg';
import actionInformation from '@ibk/shared-assets/icons/action-information.svg';
import actionNF from '@ibk/shared-assets/icons/action-nf.svg';
import actionSeeDetails from '@ibk/shared-assets/icons/action-see-details.svg';
import actionSendToClient from '@ibk/shared-assets/icons/action-send-to-client.svg';
import actionTicket from '@ibk/shared-assets/icons/action-ticket.svg';
import actionTrash from '@ibk/shared-assets/icons/action-trash.svg';
import active from '@ibk/shared-assets/icons/active.svg';
import addBank from '@ibk/shared-assets/icons/add-bank.svg';
import arrowChevronDownDark from '@ibk/shared-assets/icons/arrow-chevron-down-dark.svg';
import arrowChevronDown from '@ibk/shared-assets/icons/arrow-chevron-down.svg';
import arrowChevronLeftBold from '@ibk/shared-assets/icons/arrow-chevron-left-bold.svg';
import arrowChevronLeftGray from '@ibk/shared-assets/icons/arrow-chevron-left-gray.svg';
import arrowChevronLeft from '@ibk/shared-assets/icons/arrow-chevron-left.svg';
import arrowChevronRightBold from '@ibk/shared-assets/icons/arrow-chevron-right-bold.svg';
import arrowChevronRight from '@ibk/shared-assets/icons/arrow-chevron-right.svg';
import arrowChevronUp from '@ibk/shared-assets/icons/arrow-chevron-up.svg';
import arrowLineLeft from '@ibk/shared-assets/icons/arrow-line-left.svg';
import arrowLineRight from '@ibk/shared-assets/icons/arrow-line-right.svg';
import arrowRedo from '@ibk/shared-assets/icons/arrow-redo.svg';
import arrowRightFilled from '@ibk/shared-assets/icons/arrow-right-filled.svg';
import arrowsRepeat from '@ibk/shared-assets/icons/arrows-repeat.svg';
import arrowsRotate from '@ibk/shared-assets/icons/arrows-rotate.svg';
import attachmentClip from '@ibk/shared-assets/icons/attachment-clip.svg';
import auxilioAlimentacao from '@ibk/shared-assets/icons/auxilio-alimentacao.svg';
import auxilioRefeicao from '@ibk/shared-assets/icons/auxilio-refeicao.svg';
import bankOrange from '@ibk/shared-assets/icons/bank-orange.svg';
import bank from '@ibk/shared-assets/icons/bank.svg';
import barcodeNeutral from '@ibk/shared-assets/icons/barcode-neutral.svg';
import barcodeWhite from '@ibk/shared-assets/icons/barcode-white.svg';
import barcode from '@ibk/shared-assets/icons/barcode.svg';
import benefitAllProductsCheck from '@ibk/shared-assets/icons/benefit-all-products-check.svg';
import bigBlockCircle from '@ibk/shared-assets/icons/big-block-circle.svg';
import bigInformationCircle from '@ibk/shared-assets/icons/big-information-circle.svg';
import calendarGray from '@ibk/shared-assets/icons/calendar-gray.svg';
import calendarOrange from '@ibk/shared-assets/icons/calendar-orange.svg';
import calendar from '@ibk/shared-assets/icons/calendar.svg';
import cardChecked from '@ibk/shared-assets/icons/card-checked.svg';
import cardOrange from '@ibk/shared-assets/icons/card-orange.svg';
import card from '@ibk/shared-assets/icons/card.svg';
import cart from '@ibk/shared-assets/icons/cart.svg';
import chartLine from '@ibk/shared-assets/icons/chart-line.svg';
import chartMixedUpCircleDollar from '@ibk/shared-assets/icons/chart-mixed-up-circle-dollar.svg';
import chat from '@ibk/shared-assets/icons/chat.svg';
import checkCircleOrange from '@ibk/shared-assets/icons/check-circle-orange.svg';
import check from '@ibk/shared-assets/icons/check.svg';
import checkMarkCircle from '@ibk/shared-assets/icons/checkmark-circle.svg';
import checkMark from '@ibk/shared-assets/icons/checkmark.svg';
import circleBlock from '@ibk/shared-assets/icons/circle-block.svg';
import circleCheckmark from '@ibk/shared-assets/icons/circle-checkmark.svg';
import circleContactsOrange from '@ibk/shared-assets/icons/circle-contacts-orange.svg';
import circleError from '@ibk/shared-assets/icons/circle-error.svg';
import circleInfo from '@ibk/shared-assets/icons/circle-info.svg';
import circleMinus from '@ibk/shared-assets/icons/circle-minus.svg';
import circleQuestion from '@ibk/shared-assets/icons/circle-question.svg';
import circleReceipt from '@ibk/shared-assets/icons/circle-receipt.svg';
import circleXmark from '@ibk/shared-assets/icons/circle-xmark.svg';
import close from '@ibk/shared-assets/icons/close.svg';
import coinsDollar from '@ibk/shared-assets/icons/coins-dollar.svg';
import collapse from '@ibk/shared-assets/icons/collapse.svg';
import commentDollarOrange from '@ibk/shared-assets/icons/comment-dollar-orange.svg';
import config from '@ibk/shared-assets/icons/config.svg';
import contentInvert from '@ibk/shared-assets/icons/content-invert.svg';
import content from '@ibk/shared-assets/icons/content.svg';
import currency from '@ibk/shared-assets/icons/currency.svg';
import database from '@ibk/shared-assets/icons/database.svg';
import deleteLeft from '@ibk/shared-assets/icons/delete-left.svg';
import digitalAccountFilled from '@ibk/shared-assets/icons/digital-account-filled.svg';
import digitalAccountOrange from '@ibk/shared-assets/icons/digital-account-orange.svg';
import digitalAccount from '@ibk/shared-assets/icons/digital-account.svg';
import documentExcel from '@ibk/shared-assets/icons/document-excel.svg';
import documentImage from '@ibk/shared-assets/icons/document-image.svg';
import documentPdf from '@ibk/shared-assets/icons/document-pdf.svg';
import documentWord from '@ibk/shared-assets/icons/document-word.svg';
import document from '@ibk/shared-assets/icons/document.svg';
import dotsVerticalOrange from '@ibk/shared-assets/icons/dots-vertical-orange.svg';
import dotsVertical from '@ibk/shared-assets/icons/dots-vertical.svg';
import doubleUsers from '@ibk/shared-assets/icons/double-users.svg';
import downloadBoldOrange from '@ibk/shared-assets/icons/download-bold-orange.svg';
import downloadBold from '@ibk/shared-assets/icons/download-bold.svg';
import downloadOrange from '@ibk/shared-assets/icons/download-orange.svg';
import downloadOutline from '@ibk/shared-assets/icons/download-outline.svg';
import downloadWhite from '@ibk/shared-assets/icons/download-white.svg';
import download from '@ibk/shared-assets/icons/download.svg';
import emailOutline from '@ibk/shared-assets/icons/email-outline.svg';
import email from '@ibk/shared-assets/icons/email.svg';
import errorRedFilled from '@ibk/shared-assets/icons/error-red-filled.svg';
import faceSmileWinklFilled from '@ibk/shared-assets/icons/face-smile-winkl-filled.svg';
import faceSmileWinkl from '@ibk/shared-assets/icons/face-smile-winkl.svg';
import facebook from '@ibk/shared-assets/icons/facebook.svg';
import featureComodidade from '@ibk/shared-assets/icons/feature_comodidade.svg';
import featureIsencao from '@ibk/shared-assets/icons/feature_isencao.svg';
import featureSeguranca from '@ibk/shared-assets/icons/feature_seguranca.svg';
import featureVantagens from '@ibk/shared-assets/icons/feature_vantagens.svg';
import fileContract from '@ibk/shared-assets/icons/file-contract.svg';
import fileInvoiceDollarOrange from '@ibk/shared-assets/icons/file-invoice-dollar-orange.svg';
import fileInvoiceDollar from '@ibk/shared-assets/icons/file-invoice-dollar.svg';
import fileInvoiceIssued from '@ibk/shared-assets/icons/file-invoice-issued.svg';
import fileInvoice from '@ibk/shared-assets/icons/file-invoice.svg';
import file from '@ibk/shared-assets/icons/file.svg';
import filter from '@ibk/shared-assets/icons/filter.svg';
import food from '@ibk/shared-assets/icons/food.svg';
import giftOrange from '@ibk/shared-assets/icons/gift-orange.svg';
import handHoldingDollarBenefit from '@ibk/shared-assets/icons/hand-holding-dollar-benefit.svg';
import handHoldingDollarFilled from '@ibk/shared-assets/icons/hand-holding-dollar-filled.svg';
import handHoldingDollar from '@ibk/shared-assets/icons/hand-holding-dollar.svg';
import handshake from '@ibk/shared-assets/icons/handshake.svg';
import hexagonErrorWhite from '@ibk/shared-assets/icons/hexagon-error-white.svg';
import hideBlack from '@ibk/shared-assets/icons/hide-black.svg';
import home from '@ibk/shared-assets/icons/home.svg';
import informationBlueFilled from '@ibk/shared-assets/icons/information-blue-filled.svg';
import informationBlue from '@ibk/shared-assets/icons/information-blue.svg';
import informationFilled from '@ibk/shared-assets/icons/information-filled.svg';
import informationGray from '@ibk/shared-assets/icons/information-gray.svg';
import information from '@ibk/shared-assets/icons/information.svg';
import inputError from '@ibk/shared-assets/icons/input-error.svg';
import insideSalesCardChatDots from '@ibk/shared-assets/icons/inside-sales-card-chat-dots.svg';
import insideSalesCardSend from '@ibk/shared-assets/icons/inside-sales-card-send.svg';
import insideSalesFeatureDollar from '@ibk/shared-assets/icons/inside-sales-feature-dollar.svg';
import insideSalesFeaturePiggyBank from '@ibk/shared-assets/icons/inside-sales-feature-piggy-bank.svg';
import insideSalesFeaturePromotion from '@ibk/shared-assets/icons/inside-sales-feature-promotion.svg';
import insideSalesFeatureRepeat from '@ibk/shared-assets/icons/inside-sales-feature-repeat.svg';
import insideSalesFeatureRestaurant from '@ibk/shared-assets/icons/inside-sales-feature-restaurant.svg';
import instagram from '@ibk/shared-assets/icons/instagram.svg';
import lamp from '@ibk/shared-assets/icons/lamp.svg';
import linkBreak from '@ibk/shared-assets/icons/link-break.svg';
import link from '@ibk/shared-assets/icons/link.svg';
import linkedin from '@ibk/shared-assets/icons/linkedin.svg';
import listCheck from '@ibk/shared-assets/icons/list-check.svg';
import loaderGray from '@ibk/shared-assets/icons/loader-gray.svg';
import localization from '@ibk/shared-assets/icons/localization.svg';
import logoServicosDigitais from '@ibk/shared-assets/icons/logo-servicosdigitais.svg';
import logoTr from '@ibk/shared-assets/icons/logo-tr.svg';
import loyaltyInformation from '@ibk/shared-assets/icons/loyalty-information.svg';
import medal from '@ibk/shared-assets/icons/medal.svg';
import moveArrowDown from '@ibk/shared-assets/icons/move-down.svg';
import moveArrowUp from '@ibk/shared-assets/icons/move-up.svg';
import openFolder from '@ibk/shared-assets/icons/openFolder.svg';
import openFolderOutline from '@ibk/shared-assets/icons/openFolderOutline.svg';
import overflowMenu from '@ibk/shared-assets/icons/overflow-menu.svg';
import padlock from '@ibk/shared-assets/icons/padlock.svg';
import paymentAccountPending from '@ibk/shared-assets/icons/payment-account-pending.svg';
import payments from '@ibk/shared-assets/icons/payments.svg';
import phone from '@ibk/shared-assets/icons/phone.svg';
import pixReceive from '@ibk/shared-assets/icons/pix-receive.svg';
import pixWhite from '@ibk/shared-assets/icons/pix-white.svg';
import pix from '@ibk/shared-assets/icons/pix.svg';
import plusPrimary from '@ibk/shared-assets/icons/plus-primary.svg';
import plus from '@ibk/shared-assets/icons/plus.svg';
import portfolioBus from '@ibk/shared-assets/icons/portfolio-bus.svg';
import portfolioCart from '@ibk/shared-assets/icons/portfolio-cart.svg';
import portfolioChairOffice from '@ibk/shared-assets/icons/portfolio-chair-office.svg';
import portfolioEarth from '@ibk/shared-assets/icons/portfolio-earth.svg';
import portfolioForkKnife from '@ibk/shared-assets/icons/portfolio-fork-knife.svg';
import portfolioGasPump from '@ibk/shared-assets/icons/portfolio-gas-pump.svg';
import portfolioHandHeart from '@ibk/shared-assets/icons/portfolio-hand-heart.svg';
import portfolioRestaurant from '@ibk/shared-assets/icons/portfolio-restaurant.svg';
import portfolioTrophy from '@ibk/shared-assets/icons/portfolio-trophy.svg';
import print from '@ibk/shared-assets/icons/print.svg';
import question from '@ibk/shared-assets/icons/question.svg';
import rechargeClockGray from '@ibk/shared-assets/icons/recharge-clock-gray.svg';
import rechargeKeyGray from '@ibk/shared-assets/icons/recharge-key-gray.svg';
import rechargePaymentGray from '@ibk/shared-assets/icons/recharge-payment-gray.svg';
import rechargeSecurityGray from '@ibk/shared-assets/icons/recharge-security-gray.svg';
import rechargeTransactionGray from '@ibk/shared-assets/icons/recharge-transaction-gray.svg';
import recharge from '@ibk/shared-assets/icons/recharge.svg';
import restaurant from '@ibk/shared-assets/icons/restaurant.svg';
import rightIconLink from '@ibk/shared-assets/icons/right-icon-link.svg';
import rightIcon from '@ibk/shared-assets/icons/right-icon.svg';
import sackDollar from '@ibk/shared-assets/icons/sack-dollar.svg';
import search from '@ibk/shared-assets/icons/search.svg';
import show from '@ibk/shared-assets/icons/show_.svg';
import showBlack from '@ibk/shared-assets/icons/show-black.svg';
import signIn from '@ibk/shared-assets/icons/sign-in.svg';
import sitemap from '@ibk/shared-assets/icons/sitemap.svg';
import starOrange from '@ibk/shared-assets/icons/star-orange.svg';
import star from '@ibk/shared-assets/icons/star.svg';
import statusOutline from '@ibk/shared-assets/icons/status-outline.svg';
import status from '@ibk/shared-assets/icons/status.svg';
import stopwatch from '@ibk/shared-assets/icons/stopwatch.svg';
import store from '@ibk/shared-assets/icons/store.svg';
import successGreenFilled from '@ibk/shared-assets/icons/success-green-filled.svg';
import successGreen from '@ibk/shared-assets/icons/success-green.svg';
import trashBold from '@ibk/shared-assets/icons/trash-bold.svg';
import trash from '@ibk/shared-assets/icons/trash.svg';
import truckFast from '@ibk/shared-assets/icons/truck-fast.svg';
import uploadOrange from '@ibk/shared-assets/icons/upload-orange.svg';
import upload from '@ibk/shared-assets/icons/upload.svg';
import user from '@ibk/shared-assets/icons/user.svg';
import vrVa from '@ibk/shared-assets/icons/vr-va.svg';
import warning from '@ibk/shared-assets/icons/warning.svg';
import waypointBackground from '@ibk/shared-assets/icons/waypoint-background.svg';
import whatsapp from '@ibk/shared-assets/icons/whatsapp.svg';
import wizardCard from '@ibk/shared-assets/icons/wizard-card.svg';
import wizardDeliveryTruckInactive from '@ibk/shared-assets/icons/wizard-delivery-truck-inactive.svg';
import wizardDeliveryTruck from '@ibk/shared-assets/icons/wizard-delivery-truck.svg';
import wizardPaperPlaneInactive from '@ibk/shared-assets/icons/wizard-paper-plane-inactive.svg';
import wizardPaperPlane from '@ibk/shared-assets/icons/wizard-paper-plane.svg';
import wizardPersonWithBoxInactive from '@ibk/shared-assets/icons/wizard-person-with-box-inactive.svg';
import wizardPersonWithBox from '@ibk/shared-assets/icons/wizard-person-with-box.svg';
import wizardTruckInactive from '@ibk/shared-assets/icons/wizard-truck-inactive.svg';
import wizardTruck from '@ibk/shared-assets/icons/wizard-truck.svg';
import youtube from '@ibk/shared-assets/icons/youtube.svg';
import zoomIn from '@ibk/shared-assets/icons/zoom-in.svg';
import zoomOut from '@ibk/shared-assets/icons/zoom-out.svg';
const bell = '';
const avatar = '';
const rawIcons = {
    actionErrorRed,
    actionCheckGreen,
    errorRedFilled,
    successGreenFilled,
    informationBlueFilled,
    actionInformationDark,
    actionInformationGray,
    actionClockBlue,
    actionHexagonExclamation,
    rightIcon,
    rightIconLink,
    giftOrange,
    lamp,
    loaderGray,
    loyaltyInformation,
    close,
    calendar,
    calendarGray,
    card,
    cardOrange,
    cardChecked,
    actionBack,
    actionBlock,
    actionCopyWhite,
    actionClose,
    actionCloseOrange,
    actionCloseWhite,
    actionEdit,
    active,
    addBank,
    inputError,
    logoServicosDigitais,
    logoTr,
    show,
    showBlack,
    hideBlack,
    signIn,
    waypointBackground,
    hexagonErrorWhite,
    home,
    digitalAccount,
    digitalAccountFilled,
    digitalAccountOrange,
    bigBlockCircle,
    bigInformationCircle,
    attachmentClip,
    auxilioRefeicao,
    auxilioAlimentacao,
    vrVa,
    config,
    fileInvoiceDollar,
    fileInvoiceDollarOrange,
    fileInvoiceIssued,
    handHoldingDollar,
    handHoldingDollarBenefit,
    handHoldingDollarFilled,
    handshake,
    featureIsencao,
    featureSeguranca,
    featureVantagens,
    featureComodidade,
    faceSmileWinkl,
    faceSmileWinklFilled,
    content,
    contentInvert,
    question,
    bell,
    avatar,
    collapse,
    accountPj,
    payments,
    arrowChevronRightBold,
    arrowChevronLeftBold,
    arrowChevronRight,
    arrowLineLeft,
    arrowLineRight,
    arrowRightFilled,
    arrowChevronLeft,
    arrowChevronLeftGray,
    phone,
    whatsapp,
    pix,
    pixWhite,
    pixReceive,
    email,
    emailOutline,
    chat,
    document,
    documentPdf,
    fileContract,
    information,
    informationFilled,
    informationBlue,
    informationGray,
    facebook,
    instagram,
    insideSalesFeatureDollar,
    insideSalesFeaturePiggyBank,
    insideSalesFeaturePromotion,
    insideSalesFeatureRepeat,
    insideSalesFeatureRestaurant,
    insideSalesCardChatDots,
    insideSalesCardSend,
    link,
    linkBreak,
    linkedin,
    youtube,
    check,
    arrowsRepeat,
    arrowsRotate,
    listCheck,
    search,
    sitemap,
    database,
    plus,
    plusPrimary,
    portfolioBus,
    portfolioCart,
    portfolioChairOffice,
    portfolioEarth,
    portfolioForkKnife,
    portfolioGasPump,
    portfolioHandHeart,
    portfolioRestaurant,
    portfolioTrophy,
    print,
    currency,
    food,
    medal,
    coinsDollar,
    sackDollar,
    recharge,
    checkMarkCircle,
    circleCheckmark,
    circleError,
    circleBlock,
    status,
    statusOutline,
    store,
    stopwatch,
    bank,
    moveArrowDown,
    moveArrowUp,
    checkMark,
    padlock,
    deleteLeft,
    chevronToggle,
    successGreen,
    calendarOrange,
    circleInfo,
    circleMinus,
    circleReceipt,
    circleXmark,
    downloadBold,
    downloadBoldOrange,
    documentExcel,
    documentImage,
    documentWord,
    overflowMenu,
    bankOrange,
    arrowChevronDown,
    arrowChevronDownDark,
    arrowChevronUp,
    arrowRedo,
    starOrange,
    star,
    actionDelete,
    actionDeleteOrange,
    circleContactsOrange,
    download,
    downloadOutline,
    envelopeOpenDollar,
    actionCancelBilling,
    actionNF,
    actionSeeDetails,
    actionSendToClient,
    actionTicket,
    dotsVertical,
    dotsVerticalOrange,
    benefitAllProductsCheck,
    rechargeKeyGray,
    rechargePaymentGray,
    rechargeSecurityGray,
    rechargeTransactionGray,
    chartLine,
    chartMixedUpCircleDollar,
    copyBlack,
    copyOrange,
    downloadOrange,
    paymentAccountPending,
    downloadWhite,
    doubleUsers,
    circleQuestion,
    upload,
    uploadOrange,
    user,
    truckFast,
    sortable,
    sortAsc,
    sortDesc,
    barcode,
    barcodeNeutral,
    file,
    commentDollarOrange,
    fileArrowDown,
    wizardCard,
    wizardDeliveryTruck,
    wizardPersonWithBox,
    wizardPaperPlane,
    wizardTruck,
    wizardDeliveryTruckInactive,
    wizardPersonWithBoxInactive,
    wizardPaperPlaneInactive,
    wizardTruckInactive,
    openNew,
    location,
    phoneMobileOrange,
    phoneOrange,
    restaurant,
    cart,
    localization,
    actionTrash,
    actionInformation,
    actionBlockOrange,
    actionAdd,
    actionAddThin,
    openFolder,
    openFolderOutline,
    trash,
    trashBold,
    warning,
    rechargeClockGray,
    barcodeWhite,
    checkCircleOrange,
    zoomIn,
    zoomOut,
    fileInvoice,
    filter,
};
const icons = Object.fromEntries(Object.entries(rawIcons).filter(([, value]) => typeof value === 'string' && value !== ''));
export const Icon = ({ name, alt = '', tintColor = null, variant = 'default', disabled = false, ...props }) => {
    const src = icons[name];
    if (!src || typeof src !== 'string' || src === '') {
        console.warn(`Icon "${name}" not found or invalid`);
        return null;
    }
    if (variant === 'mask' && tintColor) {
        return (_jsx("span", { ...props, title: alt || name, "aria-hidden": !alt, "aria-disabled": disabled, style: {
                display: 'inline-block',
                width: '16px',
                height: '16px',
                backgroundColor: tintColor,
                WebkitMaskImage: `url(${src})`,
                maskImage: `url(${src})`,
                WebkitMaskRepeat: 'no-repeat',
                maskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
                maskPosition: 'center',
                WebkitMaskSize: 'contain',
                maskSize: 'contain',
                opacity: disabled ? 0.4 : 1,
                cursor: disabled ? 'not-allowed' : 'pointer',
                pointerEvents: disabled ? 'none' : 'auto',
            } }));
    }
    return _jsx("img", { src: src, alt: alt || name, "aria-label": alt || name, ...props });
};
